'use client';

import { useGetSiteConfigs } from '@/hooks/query/use-site-configs';
import { useEffect } from 'react';

export const CDNMonitorProvider = () => {
	const { SiteConfigsData } = useGetSiteConfigs();

	// FusionCDN Monitor (original mcdn beacon)
	useEffect(() => {
		// 開發環境下禁用 CDN 監控，避免 CORS 問題
		const isDev = process.env.NODE_ENV === 'development';
		
		if (SiteConfigsData?.EnableCDNMonitor && !isDev) {
			try {
				const script = document.createElement('script');
				script.async = true;
				script.setAttribute('data-id', 'pulse');
				script.setAttribute('data-trackid', 'nbk59qts');
				script.src = 'https://beacon.fusioncdn.com/pulse.js?trackid=nbk59qts';
				
				document.head.appendChild(script);

				return () => {
					try {
						if (script.parentNode) {
							document.head.removeChild(script);
						}
					} catch (error) {
						console.error('Error removing FusionCDN script:', error);
					}
				};
			} catch (error) {
				console.error('Error loading FusionCDN monitor:', error);
			}
		}
	}, [SiteConfigsData?.EnableCDNMonitor]);

	// NS1 RUM Monitor
	useEffect(() => {
		// 開發環境下禁用 NS1 監控，避免 CORS 問題
		const isDev = process.env.NODE_ENV === 'development';
		
		if (SiteConfigsData?.EnableNS1Monitor && !isDev) {
			try {
				const NS1_MONITOR_ID = '5l5012';
				
				// Set global variables
				(window as any).__nspid = NS1_MONITOR_ID;
				(window as any).__nsptags = [];

				// Create load function
				const loadNS1Script = () => {
					try {
						const script = document.createElement('script');
						script.type = 'text/javascript';
						script.async = true;
						const protocol = document.location.protocol === 'https:' ? 'https://cs' : 'http://c';
						script.src = `${protocol}.ns1p.net/p.js?a=${NS1_MONITOR_ID}`;
						
						// Ensure document.body exists
						if (document.body) {
							document.body.appendChild(script);
						} else {
							console.warn('NS1 Monitor: document.body not available');
						}
					} catch (error) {
						console.error('Error loading NS1 script:', error);
					}
				};

				// Execute on page load
				if (document.readyState === 'complete') {
					loadNS1Script();
				} else {
					window.addEventListener('load', loadNS1Script);
				}

				return () => {
					try {
						// Clean up global variables
						delete (window as any).__nspid;
						delete (window as any).__nsptags;
						window.removeEventListener('load', loadNS1Script);
					} catch (error) {
						console.error('Error cleaning up NS1 monitor:', error);
					}
				};
			} catch (error) {
				console.error('Error initializing NS1 monitor:', error);
			}
		}
	}, [SiteConfigsData?.EnableNS1Monitor]);

	return null;
}; 